var _defs, _path, _path2;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgLogoIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_2",
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 42.56 50",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, "\n            .cls-5{stroke-width:0;fill:#f25757}\n        "))), /*#__PURE__*/React.createElement("g", {
    id: "Layer_1-2"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M39.9 12.25H2.66C1.19 12.25 0 13.44 0 14.91v5.32c0 1.47 1.19 2.66 2.66 2.66h37.25c1.47 0 2.66-1.19 2.66-2.66v-5.32c0-1.47-1.19-2.66-2.66-2.66Z",
    style: {
      strokeWidth: 0,
      fill: "#61e8e1"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M35 31.78H3.38c-1 0-1.81-.81-1.81-1.81v-2.76c0-1 .81-1.82 1.81-1.82h31.63c1 0 1.81.81 1.81 1.82v2.76c0 1-.81 1.81-1.81 1.82Zm5.81 7.29v-2.76c0-1-.81-1.81-1.81-1.81H3.38c-1 0-1.81.81-1.81 1.81v2.76c0 1 .81 1.81 1.81 1.81h35.61c1 0 1.81-.81 1.81-1.81Zm-9.82 9.12v-2.76c0-1-.81-1.81-1.81-1.81H3.38c-1 0-1.81.81-1.81 1.81v2.76c0 1 .81 1.81 1.81 1.81h25.79c1 0 1.81-.81 1.81-1.81Z",
    style: {
      fill: "#1ec6ba",
      strokeWidth: 0
    }
  }), _path || (_path = /*#__PURE__*/React.createElement("path", {
    className: "cls-5",
    d: "M37.24 7.32c0-3.75-2.83-6.89-6.56-7.28h-.01c-.19-.02-.37-.03-.56-.03C30.06 0 30 0 29.94 0h-.19c-2.65 0-5.11 1.41-6.46 3.69l-.58.99-1.42 2.43-1.72-2.92-.28-.48A7.514 7.514 0 0 0 12.82 0h-.19c-.21 0-.43 0-.63.03h-.11c-.2.02-.39.05-.59.08-.34.06-.68.15-1.01.26-.17.06-.34.12-.51.19-.44.19-.86.41-1.25.68-.04.03-.09.06-.13.1-.33.24-.65.5-.93.79a7.276 7.276 0 0 0-2.14 5.18 7.319 7.319 0 0 0 7.32 7.32h4.6c-.63.75-1.27 1.2-1.9 1.32-.52.1-1 0-1.87-.23-1.06-.27-2.38-.6-4.22-.45-1.72.14-3.41.66-5.02 1.56l2.68.91-.85 2.5c1.14-.64 2.32-1.02 3.5-1.11 1.2-.1 2.06.12 2.96.35 1.01.26 2.16.55 3.56.27 1.18-.23 2.26-.79 3.25-1.7v31.94h3.94V14.63h6.69c2.75 0 5.27-1.54 6.52-3.99.52-1.03.8-2.17.8-3.33Zm-24.61 3.32c-.11 0-.22 0-.33-.02h-.09c-.06 0-.11-.02-.16-.03a3.317 3.317 0 0 1-2.68-3.86 3.32 3.32 0 0 1 2.68-2.68c.19-.03.39-.05.58-.05h.19c1.24 0 2.4.66 3.02 1.73l.29.49 2.61 4.43h-6.1Zm17.38 0h-6.18l2.89-4.92a3.51 3.51 0 0 1 3.02-1.73h.27a3.32 3.32 0 0 1 3.22 3.42 3.319 3.319 0 0 1-3.22 3.22Z"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M33.1 30.85 21.12 18.88l-.04-6.41 6.41.04 11.98 11.97s-6.36 6.36-6.37 6.36Z",
    style: {
      fill: "#dbad6a",
      strokeWidth: 0
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "m27.5 14.54-4.34 4.34 9.95 9.95 4.34-4.34-9.95-9.95Z",
    style: {
      fill: "#eac7a2",
      strokeWidth: 0
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M33.7 25.74c0-.25-.08-.44-.21-.59-.13-.15-.28-.2-.53-.29-.25-.09-.56-.2-.98-.46-.2-.13-.82-.51-1.28-1.07-.54-.66-.64-1.27-.71-1.72-.04-.25-.07-.45-.16-.52h-.17c-.25.02-.51.03-.77.02-.48-.02-.66-.07-.79-.2-.27-.29-.11-.7.02-1.02.05-.14.16-.4.13-.47 0 0-.07-.01-.11-.01-.13-.02-.33-.05-.49-.22-.27-.27-.22-.64-.19-.91 0-.05.01-.12.02-.17-.11.02-.37.1-.92.45l-.3-.49c.89-.56 1.37-.67 1.65-.4.19.18.16.45.13.68-.02.17-.04.36.03.43.03.03.07.04.17.05.13.02.3.05.44.19.29.3.12.73-.02 1.07-.05.12-.13.32-.13.41.05.01.16.03.39.03.34.01.55 0 .7-.02.21-.02.38-.03.57.12.26.21.32.53.37.88.06.41.15.91.59 1.45.4.49.96.84 1.14.95.36.23.63.33.87.41.28.1.53.19.76.44s.35.58.36.96h-.57v.01Z",
    style: {
      fill: "#9b7042",
      strokeWidth: 0
    }
  }), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    className: "cls-5",
    d: "M24.33 15.71c-.41.41-1.09.41-1.5 0-.11-.11-.2-.25-.25-.4l-2.17-2.17v-1.35h1.36l2.18 2.18c.55.21.82.82.62 1.37-.05.14-.13.27-.24.37Z"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLogoIcon);
export default __webpack_public_path__ + "static/media/logo-icon.ddeeea8e0ca46f7d9437dd2d28965e83.svg";
export { ForwardRef as ReactComponent };